"use client";

import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Marga Travel curated our entire South African holiday with such precision and care, it felt like a dream.",
  author: "Sarah M.",
  position: "Frequent Traveler",
  company: "Cape Town Explorer"
}, {
  quote: "The attention to detail in our Mauritius package was unmatched. Truly a world-class booking experience.",
  author: "David K.",
  position: "Luxury Seeker",
  company: "Global Wanderer"
}, {
  quote: "Every flight and hotel detail was handled perfectly. Marga Travel made our European tour seamless.",
  author: "Dr. Elena R.",
  position: "Academic Researcher",
  company: "Travel Enthusiast"
}, {
  quote: "Their holiday packages are not just trips; they are memories crafted with professional expertise.",
  author: "Marcus J.",
  position: "Business Executive",
  company: "Corporate Traveler"
}, {
  quote: "From the first inquiry to the final landing, the service was impeccable. Highly recommended.",
  author: "Sophie L.",
  position: "Adventure Traveler",
  company: "Solo Explorer"
}, {
  quote: "Marga Travel is where reliability meets luxury. We will definitely book our next getaway with them.",
  author: "Oliver B.",
  position: "Family Traveler",
  company: "Holiday Planner"
}];
const avatars = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/blank-profile.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/blank-profile.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/blank-profile.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/blank-profile.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/blank-profile.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/blank-profile.png"];
export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % testimonials.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  const handlePrev = () => {
    setActiveIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const handleNext = () => {
    setActiveIndex(prev => (prev + 1) % testimonials.length);
  };
  const current = testimonials[activeIndex];
  const words = current.quote.split(" ");
  return <section data-section-id="4096" id="voted-no-1-in-travel" className="relative overflow-hidden py-32 md:py-44 lg:py-[180px] bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      {}
      <svg className="pointer-events-none absolute top-1/2 right-6 hidden -translate-y-1/2 opacity-30 lg:right-16 lg:block" width="180" height="320" viewBox="0 0 180 320" fill="none" aria-hidden="true">
        <path d="M20 20 L20 80 L60 80 L60 140 L120 140 L120 200 L80 200 L80 260 L160 260 L160 300" stroke="currentColor" className="text-primary" strokeWidth="1" strokeLinecap="round" fill="none" />
        <circle cx="20" cy="20" r="3" className="fill-primary" />
        <circle cx="60" cy="80" r="3" className="fill-primary" />
        <circle cx="120" cy="140" r="3" className="fill-primary" />
        <circle cx="80" cy="200" r="3" className="fill-primary" />
        <circle cx="160" cy="300" r="3" className="fill-primary" />
      </svg>

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        {}
        <div className="mb-20 flex justify-center md:mb-28">
          <span className="font-default text-xs tracking-[0.3em] uppercase text-primary">
            — Client Reviews —
          </span>
        </div>

        {}
        <div className="grid grid-cols-12 gap-4">
          <div ref={ref} className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-2">
            {}
            <blockquote key={activeIndex} className="font-default text-4xl leading-[1.15] italic md:text-5xl lg:text-6xl xl:text-[80px] xl:leading-[1.1] text-foreground">
              <span aria-hidden="true" className="opacity-40">"</span>
              {words.map((word, i) => <span key={`${activeIndex}-${i}`} data-index={i} className="inline-block transition-all duration-700 ease-out" style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(12px)",
              transitionDelay: `${i * 40}ms`
            }}>
                  {word}&nbsp;
                </span>)}
              <span aria-hidden="true" className="opacity-40">"</span>
            </blockquote>

            {}
            <div className="mt-14 flex items-center gap-5 transition-opacity duration-700 md:mt-16" style={{
            opacity: isVisible ? 1 : 0,
            transitionDelay: `${words.length * 40 + 100}ms`
          }}>
              <img src={avatars[activeIndex]} data-wvc-srcset={`${avatars[activeIndex]}-wvc-srcset`} data-wvc-sizes={`${avatars[activeIndex]}-wvc-sizes`} alt={current.author} loading="lazy" decoding="async" className="h-16 w-16 rounded-lg border border-primary/20 object-cover shadow-md" />
              <div className="flex flex-col">
                <span className="font-default text-lg text-foreground">
                  {current.author}
                </span>
                <span className="mt-1 font-default text-[13px] tracking-[0.2em] uppercase text-primary">
                  {current.position}
                </span>
                <span className="mt-0.5 font-default text-sm italic text-foreground/50">
                  {current.company}
                </span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 flex items-center justify-between md:mt-32">
          <div className="font-default text-sm tracking-[0.2em] text-foreground/70">
            <span className="text-foreground">
              {String(activeIndex + 1).padStart(2, "0")}
            </span>
            <span className="mx-2 opacity-50">/</span>
            <span>{String(testimonials.length).padStart(2, "0")}</span>
          </div>

          <div className="flex items-center gap-3">
            <Button variant="outline" size="icon" onClick={handlePrev} aria-label="Previous testimonial" className="h-12 w-12 rounded-lg border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground">
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <Button variant="outline" size="icon" onClick={handleNext} aria-label="Next testimonial" className="h-12 w-12 rounded-lg border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground">
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}